import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';
import Swal from 'sweetalert2';

import './Home.css';

 /*
* This displays a bootstrap modal that allows the user to change assessment ownership.
* Set the property show = true to show the modal, false to close it.
*/

class ChangeAssessmentProfileModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newFirstName: null,
            newLastName: null,
            newBirthDate: null
        }
    }

    changeAssessmentProfileHandler = () => {

        if (isNullOrEmpty(this.state.newFirstName) && isNullOrEmpty(this.state.newLastName) && isNullOrEmpty(this.state.newBirthDate)) {
            alertPopup('info', "No changes made.");
            return false;
        }

        let confirmMsg = this.props.firstName + ", " + this.props.lastName + ", " + this.props.birthDate + " will be changed to ";
        confirmMsg += ((isNullOrEmpty(this.state.newFirstName)) ? this.props.firstName : this.state.newFirstName) + ", ";
        confirmMsg += ((isNullOrEmpty(this.state.newLastName)) ? this.props.lastName : this.state.newLastName) + ", ";
        confirmMsg += (isNullOrEmpty(this.state.newBirthDate)) ? this.props.birthDate : this.state.newBirthDate;
        confirmMsg += ".  NOTE!!! This change breaks any rater links you've already sent. You will need to re-generate these links and send them again. Proceed with the change?";

        // Didn't want to enclose the remainder of this function as a callback and can't simply 'return' so using Swal inline in this instance
        Swal.fire({
            text: confirmMsg,
            icon: 'warning',
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            showCancelButton: true,
            showConfirmButton: true,
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ changeButtonDisabled: true });
                let changeProfileData = {
                    personFirstName: this.state.newFirstName,
                    personLastName: this.state.newLastName,
                    personBirthDate: this.state.newBirthDate
                };

                let url = "assessment/" + this.props.assessmentId + "/profile/";
                api.post(url, changeProfileData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + authService.token
                        }
                    })
                    .then((response) => {

                        // Success is an OK (200) status code
                        if (response.status == 200) {
                            alertPopup('success', "Assessment profile changed.");
                            setTimeout(() => { this.props.closeHandler(true); }, 1000);
                            return;
                        }
                        else {
                            // Likely date problem
                            apiErrorPopup(apiResponseHandler(response));
                            return;
                        };
                    })
                    .catch((error) => {
                        // Nasty problem
                        apiErrorPopup(apiErrorHandler(error));
                        return;
                    });
            }
            else if (result.isDenied) {
                return;
            }
        });
    }

    changeHandler = (e) => {
        this.state[e.target.id] = e.target.value;
    }

    render() {
        return (
            <Fragment>
                <Modal
                    show={this.props.show}
                    onHide={this.props.closeHandler.bind(this, false)}
                    backdrop="static"
                    className="modal"
                    onClick={(e) => { e.stopPropagation(); }}
                >
                    <Modal.Header closeButton={true}>
                        <Modal.Title>Change Assessment Profile for {this.props.firstName} {this.props.lastName} {this.props.birthDate}</Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                        <Form>
                            <p>Only enter the items you wish to change and leave the others blank</p>
                            <Form.Group controlId="newFirstName">
                                <Form.Label>New First Name</Form.Label>
                                <Form.Control id="newFirstName" onChange={this.changeHandler} type="text" placeholder="New first name" />
                            </Form.Group>
                            <Form.Group controlId="newLastName">
                                <Form.Label>New Last Name</Form.Label>
                                <Form.Control id="newLastName" onChange={this.changeHandler} type="text" placeholder="New last name" />
                            </Form.Group>
                            <Form.Group controlId="newBirthDate">
                                <Form.Label>New Birth Date</Form.Label>
                                <Form.Control id="newBirthDate" onChange={this.changeHandler} type="date" placeholder="New birth date (mm/dd/yyyy)" />
                            </Form.Group>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.props.closeHandler.bind(this, false)}>Close</Button>
                        <Button variant="primary" onClick={this.changeAssessmentProfileHandler}>Change</Button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

export default ChangeAssessmentProfileModal;


// WEBPACK FOOTER //
// ./src/components/Home/ChangeAssessmentProfileModal.js